/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import React, { useContext } from 'react'
import Accordion from 'react-bootstrap/Accordion'
import { useAccordionButton } from 'react-bootstrap/AccordionButton'
import AccordionContext, {
  AccordionEventKey
} from 'react-bootstrap/AccordionContext'
import Card from 'react-bootstrap/Card'

import StructuredTextDefault from '@/components/structured-text/structured-text-default'

import minus from './minus.svg'
import plus from './plus.svg'
import * as style from './table.module.scss'

interface CustomToggleProps {
  children: React.ReactNode
  eventKey: AccordionEventKey
}

const CustomToggle = ({ children, eventKey }: CustomToggleProps) => {
  const { activeEventKey } = useContext(AccordionContext)
  const decoratedOnClick = useAccordionButton(eventKey as string)
  const isCurrentEventKey = activeEventKey === eventKey

  return (
    <p
      type="button"
      className={`${style.text} b400 m-0 d-flex justify-content-between align-items-center text-brand-primary`}
      onClick={decoratedOnClick}
    >
      {children}{' '}
      {isCurrentEventKey ? (
        <img src={minus} alt="minus" />
      ) : (
        <img src={plus} alt="plus" />
      )}
    </p>
  )
}

type ReportTableContentProps = Queries.DatoCmsTable

const ReportTableContent = ({ title, contents }: ReportTableContentProps) => {
  return (
    <section className={style.section}>
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <h2
              className={`${style.title} h200 text-uppercase text-brand-primary`}
            >
              {title}
            </h2>
          </div>
          <div className={style.contentMobile}>
            <Accordion defaultActiveKey="0">
              {contents?.length > 0 &&
                contents.map((content, index) => (
                  <div className="col-12 col-lg-4" key={index}>
                    <Card className={style.item}>
                      <Card.Header className={style.itemHeader}>
                        <CustomToggle eventKey={`${index}`}>
                          {`${index + 1}.`} {content.title}
                        </CustomToggle>
                      </Card.Header>

                      <Accordion.Collapse eventKey={`${index}`}>
                        <Card.Body className={`p-0`}>
                          <>
                            {(content?.tag || content?.subtitle) && (
                              <div className={style.wrapperInfo}>
                                {content?.subtitle && (
                                  <p className="text-base-100 b100 my-0 text-uppercase">
                                    {content?.subtitle}
                                  </p>
                                )}
                                {content?.tag && (
                                  <p className="text-base-100 b200-bold my-0">
                                    {content?.tag}
                                  </p>
                                )}
                              </div>
                            )}
                          </>
                          <div
                            className={`b100 text-base-100 ${style.content}`}
                          >
                            <StructuredTextDefault content={content.content} />
                          </div>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  </div>
                ))}
            </Accordion>
          </div>
        </div>
      </div>
      <div className={style.contentDesktop}>
        <div className="container">
          <div className="row justify-content-between">
            {contents?.length > 0 &&
              contents.map((content, index) => (
                <div className="col-4 col-xl-3" key={`table-content-${index}`}>
                  <article>
                    <p
                      className={`${style.number} b400 my-0 text-brand-primary`}
                    >
                      {content?.number}
                    </p>
                    <h3
                      className={`${style.title} b400 my-0 text-brand-primary`}
                    >
                      {content?.title}
                    </h3>
                    {(content?.tag || content?.subtitle) && (
                      <div className={style.wrapperInfo}>
                        {content?.subtitle && (
                          <p className="text-base-100 b100 my-0 text-uppercase">
                            {content?.subtitle}
                          </p>
                        )}
                        {content?.tag && (
                          <p className="text-base-100 b200-bold my-0">
                            {content?.tag}
                          </p>
                        )}
                      </div>
                    )}
                    <div className={`${style.content} b100`}>
                      <StructuredTextDefault content={content.content} />
                    </div>
                  </article>
                </div>
              ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default ReportTableContent
